import React from "react";
import Grid from "@mui/material/Grid";
import { ThemeProvider } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import { useTranslation } from "@limitless/common/hooks";
import { useExpertOnboardingMetrics } from "@limitless/expert";
import { usePageViewRecorder } from "@limitless/analytics";
import useCustomTheme from "../../../utils/hooks/useCustomTheme";
import ExpertMemberDetailList from "./ExpertMemberDetailList";

const ExpertMemberDetailsOverview = () => {
    const { t } = useTranslation();
    const theme = useCustomTheme();

    usePageViewRecorder("Onboarding - Member Details");

    const { memberDetails } = useExpertOnboardingMetrics(t);

    const detailSections = [
        { title: "To do", checks: memberDetails.todo },
        { title: "Awaiting verification", checks: memberDetails.awaitingVerification },
        { title: "Completed", checks: memberDetails.verified, readOnly: true }
    ];

    return (
        <ThemeProvider theme={theme}>
            <Typography
                variant="body2"
                color={theme.palette.text.secondary}
                style={{ marginBottom: 16, paddingLeft: 20 }}
            >
                {t(
                    "As part of the onboarding process, Limitless needs a few more details from you. In some cases, this information may need to be verified by either our team or the client to ensure accuracy."
                )}
            </Typography>

            <Grid
                container
                wrap="nowrap"
                spacing={1}
                sx={{
                    width: {
                        xs: "0%",
                        md: "0%",
                        lg: "105%"
                    }
                }}
            >
                {detailSections.map(({ title, checks, readOnly }, index) => (
                    <Grid key={index} item xs={12} md={8} lg={8} paddingLeft={"14px"} justifyContent={"space-between"}>
                        <ExpertMemberDetailList title={title} checks={checks} readOnly={readOnly} />
                    </Grid>
                ))}
            </Grid>
        </ThemeProvider>
    );
};

export default ExpertMemberDetailsOverview;
